var React = require('react');

function IcMail (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.85398 6L11.4782 11.5064C11.7537 11.7054 12.2464 11.7053 12.5218 11.5064L20.146 6H3.85398ZM21 6.61671L13.1073 12.317C12.4825 12.7683 11.5178 12.7685 10.8927 12.317L3 6.61671V15.9999C3 16.5522 3.44772 16.9999 4 16.9999H20C20.5523 16.9999 21 16.5522 21 15.9999V6.61671ZM3 5H21C21.5523 5 22 5.44772 22 6V16C22 17.1046 21.1046 18 20 18H4C2.89543 18 2 17.1046 2 16V6C2 5.44772 2.44772 5 3 5Z","fill":"#17181A"}));
}

IcMail.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IcMail;

IcMail.default = IcMail;
